import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'

const FETCH_BIN_REQUEST = 'Bin/FETCH_BIN_REQUEST'
const FETCH_BIN_SUCCESS = 'Bin/FETCH_BIN_SUCCESS'
const FETCH_BIN_FAILURE = 'Bin/FETCH_BIN_FAILURE'

const FETCH_BIN_LOCATION_REQUEST = 'Bin/FETCH_BIN_LOCATION_REQUEST'
const FETCH_BIN_LOCATION_SUCCESS = 'Bin/FETCH_BIN_LOCATION_SUCCESS'
const FETCH_BIN_LOCATION_FAILURE = 'Bin/FETCH_BIN_LOCATION_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  binList: [],
  binLocationList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BIN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        binList: action.payload
      }
    case FETCH_BIN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BIN_LOCATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BIN_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        binLocationList: action.payload
      }
    case FETCH_BIN_LOCATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const fetchBin = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BIN_REQUEST
      })

      const response = await API.get(EndPoints.BIN + '/', {
        params: options
      })

      dispatch({
        type: FETCH_BIN_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BIN_FAILURE
      })
    }
  }
}

export const fetchBinLocation = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BIN_LOCATION_REQUEST
      })

      const response = await API.get(EndPoints.BIN + `/location`, {
        params: options
      })

      dispatch({
        type: FETCH_BIN_LOCATION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BIN_LOCATION_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/bin.js